"use client";

import { c as _c } from "react/compiler-runtime";
import { ReferralAuthInstructionsCard } from "@/src/components/tasks/referral-auth-instructions-card";
import { ReferralEligibilityCard } from "@/src/components/tasks/referral-eligibility-card";
import { useReferralAuthOpenAuthorization } from "@/src/hooks/use-referral-auth-open-authorization";
import { deriveReferralAuthorizationFromStedi } from "@/src/lib/clearinghouse/stedi/derive-referral-authorization-from-stedi";
import { resolveStediEligibilityDisplay } from "@/src/lib/clearinghouse/stedi/extract-eligibility-summary";
import { useStediEligibilityCheck } from "@/src/lib/data-fetchers/stedi-eligibility-check-fetchers";
import { buildAutonomyReferralAuthInstruction, canStartReferralAuthTrackingCase, getReferralAuthTrackingCaseButtonTooltip } from "@/src/lib/prior-authorization/autonomy-referral-auth-instructions";
import { resolveReferralAuthOnFile } from "@/src/lib/prior-authorization/referral-auth-on-file";
import type { PriorAuthorization } from "@/src/models/documents/prior-authorization/prior-authorization";
import { Referral } from "@/src/models/documents/referral";
interface AutonomyReferralAuthInstructionsProps {
  referral: Referral;
  linkedPriorAuthorizations: PriorAuthorization[];
  taskId: string;
  taskPriorAuthorization?: PriorAuthorization | null;
  startTrackingCaseDisabled?: boolean;
}
export function AutonomyReferralAuthInstructions(t0) {
  const $ = _c(17);
  const {
    referral,
    linkedPriorAuthorizations,
    taskId,
    taskPriorAuthorization,
    startTrackingCaseDisabled: t1
  } = t0;
  const startTrackingCaseDisabled = t1 === undefined ? false : t1;
  const {
    eligibilityCheck,
    isLoading
  } = useStediEligibilityCheck(referral.id);
  const eligibilityDisplay = eligibilityCheck ? resolveStediEligibilityDisplay(eligibilityCheck) : null;
  const teStatus = eligibilityDisplay ? deriveReferralAuthorizationFromStedi(eligibilityDisplay.officeVisitRequiresAuth, eligibilityDisplay.checkFailed).teStatus : null;
  const authOnFile = resolveReferralAuthOnFile(referral, linkedPriorAuthorizations, taskPriorAuthorization);
  const canStartTrackingCase = canStartReferralAuthTrackingCase({
    isLoading,
    hasEligibilityCheck: !!eligibilityCheck,
    teStatus,
    planType: eligibilityDisplay?.planType ?? null
  });
  let t2;
  if ($[0] !== linkedPriorAuthorizations || $[1] !== taskId || $[2] !== taskPriorAuthorization) {
    t2 = {
      taskId,
      taskPriorAuthorization,
      linkedPriorAuthorizations
    };
    $[0] = linkedPriorAuthorizations;
    $[1] = taskId;
    $[2] = taskPriorAuthorization;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    handleOpenAuthorization,
    isOpeningAuthorization
  } = useReferralAuthOpenAuthorization(t2);
  const isButtonDisabled = startTrackingCaseDisabled || isOpeningAuthorization || !canStartTrackingCase;
  const openButtonTooltip = getReferralAuthTrackingCaseButtonTooltip({
    isLoading,
    hasEligibilityCheck: !!eligibilityCheck,
    teStatus,
    planType: eligibilityDisplay?.planType ?? null,
    isSubmitting: startTrackingCaseDisabled
  });
  const t3 = "flex flex-col gap-4";
  const T0 = ReferralAuthInstructionsCard;
  const t4 = buildAutonomyReferralAuthInstruction({
    isLoading,
    hasEligibilityCheck: !!eligibilityCheck,
    teStatus,
    planType: eligibilityDisplay?.planType ?? null,
    authOnFile
  });
  let t5;
  if ($[4] !== T0 || $[5] !== handleOpenAuthorization || $[6] !== isButtonDisabled || $[7] !== isOpeningAuthorization || $[8] !== openButtonTooltip || $[9] !== t4) {
    t5 = <T0 instruction={t4} openButtonTooltip={openButtonTooltip} isOpenButtonDisabled={isButtonDisabled} isOpening={isOpeningAuthorization} onOpenAuthorization={handleOpenAuthorization} />;
    $[4] = T0;
    $[5] = handleOpenAuthorization;
    $[6] = isButtonDisabled;
    $[7] = isOpeningAuthorization;
    $[8] = openButtonTooltip;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== referral.id || $[12] !== taskId) {
    t6 = <ReferralEligibilityCard referralId={referral.id} taskId={taskId} />;
    $[11] = referral.id;
    $[12] = taskId;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className={t3}>{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}